export const AUDIO_SPEED_PRESETS = [
	0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.5, 3, 4,
] as const